// removed by extract-text-webpack-plugin
module.exports = {"row":"OptInBox-row-35c0d203","col":"OptInBox-col-7c18e84a","button":"OptInBox-button-2c364df8","bannerAd":"OptInBox-bannerAd-f7a00283","rail":"OptInBox-rail-03a947fa","container":"OptInBox-container-2dc37a83","divider":"OptInBox-divider-6a51c75b"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OptIn/OptInBox.scss
// module id = 886
// module chunks = 0